import React from 'react'
import Spinner from 'react-bootstrap/Spinner'
import DatumLogo from 'assets/DatumInsights/datum-logo.webp'
import ThirdLineLogo from 'assets/MainLogo/Navy/ThirdLine Main Logo Navy.svg'
import './datum.css'

const DatumEmptyPage = () => (
  <div style={{ backgroundColor: '#ffffff' }}>
    <nav
      className="navbar fixed-top datum-navbar flex-md-nowrap p-0 shadow-sm"
      style={{ minHeight: '54px' }}
    >
      <div
        className="navbar-brand d-flex align-items-center"
        style={{ minHeight: '54px', width: '200px' }}
      >
        <img
          src={DatumLogo}
          className="ms-3"
          alt="Datum Insights Logo"
          style={{ maxHeight: '35px' }}
        />
        <img
          src={ThirdLineLogo}
          className="ms-3"
          alt="ThirdLine Logo"
          style={{ maxHeight: '22.5px' }}
        />
      </div>
      <div className="container-fluid">
        <h5 className="text-left mt-2 datum-title mb-0">Datum Insights</h5>
      </div>
    </nav>
    <nav className="datum-sidebar" />
    <main className="datum-main" role="main">
      <div className="vh-100 d-flex align-items-center justify-content-center">
        <Spinner animation="grow" variant="warning" />
      </div>
    </main>
  </div>
)

export default DatumEmptyPage
